import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import type { AdminAuthResult } from '@repo/shared-types';
import { Button } from '@repo/ui/src/components/ui/button';
import { Input } from '@repo/ui/src/components/ui/input';
import { Label } from '@repo/ui/src/components/ui/label';
import { adminFetchPublicApi } from '../lib/api';
import { useAdminAuthStore } from '../stores/adminAuthStore';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const setAuth = useAdminAuthStore((s) => s.setAuth);

  const login = useMutation({
    mutationFn: () =>
      adminFetchPublicApi<AdminAuthResult>('/admin/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      }),
    onSuccess: (data) => {
      setAuth({
        user: data.user,
        tokens: { accessToken: data.accessToken, refreshToken: data.refreshToken },
      });
      navigate('/orgs');
    },
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    login.mutate();
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-50 px-4">
      <div className="w-full max-w-sm rounded-lg border border-surface-200 bg-surface-0 p-8 shadow-sm">
        <h1 className="text-2xl font-semibold tracking-tight text-center text-surface-900">
          LopHoc Admin
        </h1>
        <p className="mt-1.5 text-center text-sm text-surface-500">
          Đăng nhập để quản lý nền tảng
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@lophoc.app"
              className="mt-1.5"
              autoComplete="email"
              autoFocus
              required
            />
          </div>

          <div>
            <Label htmlFor="password">Mật khẩu</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5"
              autoComplete="current-password"
              required
            />
          </div>

          {login.isError && (
            <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2.5">
              <p className="text-sm text-red-700">{(login.error as Error).message}</p>
            </div>
          )}

          <Button type="submit" className="w-full" disabled={login.isPending}>
            {login.isPending ? 'Đang đăng nhập…' : 'Đăng nhập'}
          </Button>
        </form>
      </div>
    </div>
  );
}
